import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function Blog() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetch("/blog.json")
      .then((res) => res.json())
      .then((data) => setPosts(data))
      .catch((err) => console.error("Error loading blog:", err));
  }, []);

  return (
    <div style={{ padding: "40px" }}>
      <h1 style={{ textAlign: "center" }}>Blog</h1>

      <div className="blog-grid">
        {posts.map((post) => (
          <Link
            key={post.Id}
            to={`/blogpost/${post.Id}`}
            className="blog-tile"
          >
            <h2>{post.Title}</h2>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Blog;
